<template>
  <Main />
</template>

<script>
// @ is an alias to /src
import Main from "@/views/Main";

export default {
  name: "App",
  components: {
    Main
  }
};
</script>

<style></style>
